/** USER */
export const ADD_USER = "add_user"
export const DEACTIVATE_USER = "deactivate_user"
export const ACTIVATE_USER = "activate_user"
export const CONNECTED_USER = "connected_user"


/** ANIMAL */
export const ANIMAL = 'animal'

/** RDV */
export const RDV = 'rdv'
export const CANCEL_RDV = 'cancel_rdv'
export const UPDATE_RDV = 'update_rdv'
export const VALIDATE_RDV = 'validate_rdv'



export const ADD_BILL = 'add_bill'
export const UPDATE_BILL = 'update_bill'
export const PAY_BILL = 'pay_bill'
export const CANCEL_BILL = 'cancel_bill'
export const SEND_BILL_TO_USER = 'send_bill'
export const DELETE_BILL = 'delete_bill'

/** PACK */

export const PACK_SUBSCRIPTION = 'pack_subscription'
export const PACK_SUBSCRIPTION_REVIEW = 'pack_subscription_review'
export const PACK_SUBSCRIPTION_MIGRATE = 'pack_subscription_migrate'

export const NOTIFICATION_ICON = (type) => {
    switch(type){
        case ADD_USER: return 'la-user-plus';
        case DEACTIVATE_USER: return 'la-user-times';
        case ACTIVATE_USER: return 'la-user-check';
        case CONNECTED_USER: return 'la-user-shield'


        case ANIMAL: return 'la-dog';
        case RDV: return 'la-calendar';
        case CANCEL_RDV: return 'la-calendar-times';
        case UPDATE_RDV: return 'la-calendar-day';
        case VALIDATE_RDV: return 'la-calendar-check'


        /** Facturation */
        case  ADD_BILL: return 'la-money-bill';
        case  DELETE_BILL:  return 'la-money-bill';
        case  UPDATE_BILL: return 'la-money-bill-alt';
        case  PAY_BILL: return 'la-money-bill-wave';
        case  CANCEL_BILL: return 'la-money-bill-wave';
        case  SEND_BILL_TO_USER:  return 'la-paper-plane'

        /** Pack */

        

        default: return 'la-info-circle'
    }
}